import { useState } from 'react';
import { MessageCircle, Mail } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const SUPPORT_EMAIL = 'support@qinv.io';

/**
 * Floating support button + modal. Points users to email support@qinv.io.
 * Self-contained (fixed to the viewport) so it can be mounted once per screen.
 */
export function SupportButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Support"
        className="fixed bottom-24 right-4 md:bottom-5 md:right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white shadow-lg transition-transform hover:scale-105 active:scale-95"
      >
        <MessageCircle className="h-6 w-6" />
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/15 text-primary">
              <MessageCircle className="h-6 w-6" />
            </div>
            <DialogTitle className="text-center font-jakarta text-xl font-semibold text-white">
              Need a hand?
            </DialogTitle>
            <DialogDescription className="text-center font-jakarta text-sm text-text-muted">
              We&apos;re here to help. If you have a question about your portfolio,
              a transaction, or anything else, send us an email and we&apos;ll get
              back to you as soon as we can.
            </DialogDescription>
          </DialogHeader>

          <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-2 block">
            <Button variant="primary" className="w-full gap-2">
              <Mail className="h-4 w-4" />
              Email {SUPPORT_EMAIL}
            </Button>
          </a>

          <p className="mt-3 text-center font-jakarta text-xs text-text-muted">
            Or write to{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary hover:underline">
              {SUPPORT_EMAIL}
            </a>
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default SupportButton;
